const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");
const form = require('../../deploynaut/js/Form.jsx');

let RemoveSecretForm = createReactClass({
	render: function() {
		return (
			<form.Form
				ref="removeSecretForm"
				url={this.props.actionURL}
				securityID={this.props.model.SecurityID}
				buttonTitle="Remove"
				buttonSubmittingTitle="Removing"
				afterSuccess={this.props.afterSuccess}
				cancelButton={<button className="btn btn-link" onClick={this.props.cancelHandler}>Cancel</button>}
			>
				<p>Removing this secret is a permanent action and cannot be un-done. Please ensure your deployed website
					does not require this secret before removing it.</p>

				<p>Are you sure you want to remove this secret?</p>
				<form.Hidden name='ID' value={this.props.id} />
			</form.Form>
		);
	}
});

module.exports = RemoveSecretForm;
